import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#37474F',
        primary2: '#455A64',
        secondary: '#78909C',
        accent: '#546E7A',
        bright: '#ffffff',
        success: '#43A047',
        info: '#1E88E5',
        error: '#E53935',
        warning: '#FB8C00',
        icon: '#546E7A',
        background: '#FAFAFA',
        surface: '#FFFFFF',
        glass: 'rgba(255, 255, 255, 0.7)',
      },
      dark: {
        primary: '#546E7A',
        primary2: '#455A64',
        secondary: '#78909C',
        accent: '#90A4AE',
        bright: '#ffffff',
        success: '#66BB6A',
        info: '#42A5F5',
        error: '#EF5350',
        warning: '#FFA726',
        icon: '#B0BEC5',
        background: '#1a1a1a',
        surface: '#262626',
        glass: 'rgba(38, 38, 38, 0.85)',
      },
    },
  },
})
